export const languages: Record<string, () => Promise<unknown>> = {
  ...import.meta.glob(['/locale/*.json', '!/locale/*_old.json']),
  // Keep the personal Korean catalog in source control. Upstream translation
  // updates and their completeness filter must not remove it from our builds.
  '/locale/ko.json': import.meta.glob('./locales/ko.json')['./locales/ko.json'],
};
